import { TSessionDetails } from '@api/io/session.io';
import { TConfig } from '@fe-core';

export type TSessionStates =
  | 'sessionFull'
  | 'managerApprovalRequired'
  | 'disenrollmentUnavailable'
  | 'waitlistFull'
  | 'placedInWaitlist'
  | 'numberedPlaceInWaitlist'
  | 'enrollmentPending'
  | 'enrollmentPendingManagerApproval';

export const getSessionStates = (
  sessionDetails: TSessionDetails,
  webfeatures: TConfig['config']['webfeatures'],
): Record<TSessionStates, boolean> => {
  const {
    waitlist,
    enrollment,
    disenrollment,
    selfEnrollmentStatus,
    selfEnrollmentProgress,
    managed,
  } = sessionDetails;

  const enrollmentOverLimit = !!(
    enrollment?.maximum?.limit &&
    enrollment.current?.limit &&
    enrollment.maximum.limit <= enrollment.current.limit
  );

  const isEnrolled = selfEnrollmentStatus === 'active';
  // intentionally using != instead of !==.
  const inWaitlist = waitlist?.enabled && waitlist?.seatNumber != null;

  const enrollmentPending =
    !inWaitlist &&
    selfEnrollmentStatus === 'enrolled_confirmed' &&
    selfEnrollmentProgress === 'unknown';

  const managedEnabled = !!webfeatures?.['teamview'] && managed;

  return {
    // enrollment related
    sessionFull: !isEnrolled && enrollmentOverLimit,
    managerApprovalRequired:
      managedEnabled &&
      selfEnrollmentStatus === 'unenrolled' &&
      !(enrollment.enabled && enrollment.mode === 'direct'),

    // disenrollment related
    disenrollmentUnavailable: !disenrollment?.enabled,

    // waitlist related
    waitlistFull: waitlist?.enabled && !waitlist.seatsAvailable,
    placedInWaitlist: inWaitlist && !waitlist.displayDetails,
    numberedPlaceInWaitlist: inWaitlist && waitlist.displayDetails,

    // moderated enrollment
    enrollmentPending: enrollmentPending && !managedEnabled,
    enrollmentPendingManagerApproval: enrollmentPending && managedEnabled,
  };
};
